import { makeStyles } from '@material-ui/core/styles';

import type { CustomTheme } from 'theme';
import type { PageStylesProps } from 'pages/shared';

export type SidebarStylesProps = PageStylesProps;

const useStyles = makeStyles((theme: CustomTheme) => ({
  sidebarBackground: {
    backgroundColor: theme.palette.grey[100],
  },
  sidebarContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      padding: `0 ${theme.spacing(4)}px`,
    },
  },
  sidebarTextSection: ({ firstChildTopSpacing = 0 }: SidebarStylesProps) => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(3),
    '&:first-child': {
      marginTop: theme.spacing(firstChildTopSpacing),
    },
    '&:last-child': {
      marginBottom: 'inherit',
    },
  }),
}));

export default useStyles;
